import type React from 'react';

interface BrandLogoProps {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function BrandLogo({ src, alt = 'Brand logo', width = 120, height, className, style }: BrandLogoProps) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={{ display: 'block', ...style }}
    />
  );
}
